export class LoadingController {
    constructor(message, $translate) {
        this._message = message;
        this.$translate = $translate;
        this.activate();
    }

    activate() {
        var message = this._message || 'authentication.loading';
        this.$translate(message).then(translation => { this._setTranslation(translation); });
    }

    _setTranslation(translation) {
        this.translation = translation;
    }
}

LoadingController.$inject = ['message', '$translate'];